'use client';

import { Menu, Button, Icon } from '@chakra-ui/react';
import { IoChevronDown } from 'react-icons/io5';
import { RiGlobalLine } from 'react-icons/ri';
import { usePathname, useRouter } from '@/i18n/navigation';
import { useLocale } from 'next-intl';
import { useState } from 'react';

const SUPPORTED_LOCALES = ['en', 'ru', 'kz'];

export default function LanguageSwitcherMenu() {
  const [open, setOpen] = useState(false);
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();

  const handleChange = (lang: string) => {
    if (lang === locale) return;

    router.replace(pathname, { locale: lang });
  };

  return (
    <Menu.Root onOpenChange={(v) => setOpen(v.open)}>
      <Menu.Trigger asChild>
        <Button variant="plain" size="sm" p={0} gap="6px">
          <Icon boxSize={5}><RiGlobalLine /></Icon>
          {locale.toUpperCase()}
          <Icon
            boxSize={4}
            transform={open ? 'rotate(180deg)' : 'rotate(0deg)'}
            transition="transform 0.2s ease"
          >
            <IoChevronDown />
          </Icon>
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content>
          <Menu.RadioItemGroup
            value={locale ?? 'en'}
            onValueChange={(e) => handleChange(e.value)}
          >
            {SUPPORTED_LOCALES.map((lang) => (
              <Menu.RadioItem key={lang} value={lang}>
                <Menu.ItemText style={{ textTransform: 'uppercase' }}>{lang.toUpperCase()}</Menu.ItemText>
                <Menu.ItemIndicator />
              </Menu.RadioItem>
            ))}
          </Menu.RadioItemGroup>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}
